import React, { useState, useEffect } from "react";
import {
  Box,
  Stack,
  Typography,
  Button,
  CircularProgress,
  TextField,
} from "@mui/material";
import toast from "react-hot-toast";
import axios from "axios";
import { URL } from "../config";

const RequestModal = ({ onClose, request }) => {
  const [requestName, setRequestName] = useState(request?.requestName || "");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setRequestName(request?.requestName || "");
  }, [request]);

  const handleSubmit = async () => {
    if (!requestName.trim()) {
      toast.error("Please enter request name!");
      return;
    }

    setLoading(true);
    try {
      if (request) {
        await axios.patch(`${URL}/requests/${request.requestId}`, {
          requestName,
        });
        toast.success("Request updated successfully!");
      } else {
        await axios.post(`${URL}/requests`, {
          requestName,
        });
        toast.success("Request added successfully!");
      }
      setTimeout(() => onClose?.(), 500);
    } catch (err) {
      console.error(err);
      toast.error("Operation failed!");
    } finally {
      setLoading(false);
    }
  };

  const fieldStyle = {
    "& .MuiOutlinedInput-root": {
      minHeight: "28px",
      fontSize: "14px",
      "& fieldset": { borderColor: "#c4c4c4" },
      "&:hover fieldset": { borderColor: "#184459ff" },
      "&.Mui-focused fieldset": {
        borderColor: "#c4c4c4",
        borderWidth: "1.5px",
      },
    },
    "& .MuiInputLabel-root": {
      fontSize: "18px",
      color: "#184459ff",
      fontWeight: 600,
    },
    "& .MuiInputLabel-root.Mui-focused": { color: "#184459ff" },
  };

  return (
    <Box
      sx={{
        position: "fixed",
        inset: 0,
        bgcolor: "rgba(0,0,0,0.6)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 1300,
        p: 2,
      }}
    >
      <Box sx={{ width: { xs: "90%", sm: 400 }, bgcolor: "#fff", borderRadius: 2, p: 3 }}>
        <Typography variant="h6" sx={{ textAlign: "center", color: "#184459ff", mb: 2 }}>
          {request ? "Edit Request" : "Add Request"}
        </Typography>

        <Stack spacing={2}>
          <TextField
            fullWidth
            label="Request Name"
            size="small"
            value={requestName}
            onChange={(e) => setRequestName(e.target.value)}
            sx={fieldStyle}
            InputLabelProps={{ shrink: true }}
          />

          <Stack direction="row" spacing={1} justifyContent="flex-end">
            <Button
              variant="contained"
              sx={{ backgroundColor: "#184459ff", "&:hover": { backgroundColor: "#184459ff" } }}
              onClick={handleSubmit}
              startIcon={loading && <CircularProgress size={18} />}
            >
              {loading ? "Saving..." : request ? "Update" : "Save"}
            </Button>

            <Button
              variant="contained"
              sx={{ backgroundColor: "#757575ff", "&:hover": { backgroundColor: "#757575ff" } }}
              onClick={onClose}
            >
              Close
            </Button>
          </Stack>
        </Stack>
      </Box>
    </Box>
  );
};

export default RequestModal;
